// ** MUI Imports
import { Theme } from '@mui/material';

const GlobalStyles = (theme: Theme) => {
  return {
    body: {
      margin: 0,
    },
    code: {
      fontFamily: 'source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace',
    },
    ul: {
      marginTop: 8,
      marginBottom: 8,
      paddingLeft: 20,
    },
  };
};

export default GlobalStyles;
